import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
    token: null,
    userId: null,
    userType: null,
    authRedirectPath: '/',
    scouts: [],
    drivers: [],
    mulchLog: [],
    scoutsLastGot: null,
    deliveryOrders:[],
    orders: [],
    deliveryProgress: [],
    driver: {
        driverId: 0,
        firstName: '',
        firstName_valid: false,
        firstName_touched: false,
        lastName: '',
        lastName_valid: false,
        lastName_touched: false,
        phone: '',
        phone_valid: false,
        phone_touched: false,
        numberOfBags: '',
        numberOfBags_valid: false,
        numberOfBags_touched: false,
        status: '',
        carNumber: ''
    },
    added: false,
    update: false,
    deleted: false,
    cities: [],
    deliveryLookup: [],
    ordersGot: false,
    scoutOrdersGot: false,
    order: {
        orderId: 0,
        isInArea: null,
        userId: 0,
        name: '',
        name_valid: false,
        name_touched: false,
        address: '',
        address_valid: false,
        address_touched: false,
        city: '',
        city_valid: false,
        city_touched: false,
        zip: '',
        zip_valid: false,
        zip_touched: false,
        phone: '',
        phone_valid: true,
        phone_touched: false,
        email: '',
        email_valid: true,
        email_touched: false,
        cedarBags: 0,
        cedarBags_valid: false,
        cedarBags_touched: false,
        hardwoodBags: 0,
        hardwoodBags_valid: false,
        hardwoodBags_touched: false,
        blackBags: 0,
        blackBags_valid: false,
        blackBags_touched: false,
        redBags: 0,
        redBags_valid: false,
        redBags_touched: false,
        cyprusBag: 0,
        cyprusBags_valid: true,
        cyprusBags_touched: false,
        deliveryType: 'pickup',
        deliveryType_valid: true,
        deliveryType_touched: false,
        notes: '',
        notes_valid: true,
        notes_touched: false,
        status: '',
        paymentStatus: 'unpaid',
        geoLat: 0.00,
        geoLon: 0.00,
        donation: 0,
        donation_valid: true,
        donation_touched: false,
        cashAmount: 0,
        cashAmount_valid: true,
        cashAmount_touched: false,
        checkAmount: 0,
        checkAmount_valid: true,
        checkAmount_touched: false,
        checkNumber: '',
        checkNumber_valid: true,
        checkNumber_touched: false,
        total: 0,
        totalBags: 0,
        isApproved: false,
        inDeliveryArea: false,
        isSuspect: false,
        geoAddress: '',
        touched: '',
        touchedByAdmin: ''
        
    },
    searchCriteria : '',
    searchResults: [],
    scoutsWithApprovals:[],
    deliveries:[],
    drivers:[],
    delivery: null,
    purchased: false,
    submitted: false,
    updated: false,
    deleted: false,
    loading: false,
    callList: [],
    mulchYear: null,
    errorMessage: null,
    scoutSummary: null,
    pickupSummary: null,
    pickupCreated: false
};

const initDriver = (state,action) => {
    return {
        ...state,
        deleted: false,
        added: false,
        updated: false,
        driver: {
            driverId: 0,
            firstName: '',
            lastName: '',
            phone: '',
            numberOfBags: '',
            firstName_valid: false,
            lastName_valid: false,
            phone_valid: false,
            numberOfBags_valid: false,
            firstName_touched: false,
            lastName_touched: false,
            phone_touched: false,
            numberOfBags_touched: false,
            status: '',
            carNumber: ''
        }
    }
}

const initSearchResults = (state,actions) => {
    return {
        ...state,
        searchResults: null
    }
}

const initOrder = (state, action) => {
    return {
        ...state,
        submitted: false,
        errorMessage: null,
        order: {
            ...state.order,
            orderId: 0,
            isInArea: null,
            userId: 0,
            name: '',
            name_valid: false,
            name_touched: false,
            address: '',
            address_valid: false,
            address_touched: false,
            city: '',
            city_valid: false,
            city_touched: false,
            zip: '',
            zip_valid: false,
            zip_touched: false,
            phone: '',
            phone_valid: true,
            phone_touched: false,
            email: '',
            email_valid: true,
            email_touched: false,
            cedarBags: 0,
            cedarBags_valid: false,
            cedarBags_touched: false,
            hardwoodBags: 0,
            hardwoodBags_valid: false,
            hardwoodBags_touched: false,
            blackBags: 0,
            blackBags_valid: false,
            blackBags_touched: false,
            redBags: 0,
            redBags_valid: false,
            redBags_touched: false,
            cyprusBag: 0,
            cyprusBags_valid: true,
            cyprusBags_touched: false,
            deliveryType: 'pickup',
            deliveryType_valid: true,
            deliveryType_touched: false,
            notes: '',
            notes_valid: true,
            notes_touched: false,
            status: '',
            paymentStatus: 'unpaid',
            geoLat: 0.00,
            geoLon: 0.00,
            donation: 0,
            donation_valid: true,
            donation_touched: false,
            cashAmount: 0,
            cashAmount_valid: true,
            cashAmount_touched: false,
            checkAmount: 0,
            checkAmount_valid: true,
            checkAmount_touched: false,
            checkNumber: '',
            checkNumber_valid: true,
            checkNumber_touched: false,
            total: 0,
            totalBags: 0,
            isApproved: false,
            inDeliveryArea: false,
            isSuspect: false,
            geoAddress: '',
            touched: '',
            touchedByAdmin: ''
        }
    };
};

const setEditOrder = (state, action) => {
    return {
        ...state,
        submitted: false,
        errorMessage: null,
        order: {
            ...state.order,
            orderId : action.orderData.orderId,
            userId : action.orderData.userId,
            isInArea : action.orderData.inDeliveryArea,
            name : action.orderData.name,
            name_valid : true,
            name_touched : true,
            address : action.orderData.address,
            address_valid : true,
            address_touched : false,
            city : action.orderData.city,
            city_valid : true,
            city_touched : false,
            zip : action.orderData.zip,
            zip_valid : true,
            zip_touched : false,
            phone : action.orderData.phone,
            phone_valid : true,
            phone_touched : false,
            email : action.orderData.email,
            email_valid : true,
            email_touched : false,
            cedarBags : action.orderData.cedarBags,
            cedarBags_valid : true,
            cedarBags_touched : false,
            hardwoodBags : action.orderData.hardwoodBags,
            hardwoodBags_valid : true,
            hardwoodBags_touched : false,
            blackBags : action.orderData.blackBags,
            blackBags_valid : true,
            blackBags_touched : false,
            redBags : action.orderData.redBags,
            redBags_valid : true,
            redBags_touched : false,
            cyprusBag : 0,
            cyprusBags_valid : true,
            cyprusBags_touched : false,
            deliveryType : action.orderData.deliveryType,
            deliveryType_valid : true,
            deliveryType_touched : false,
            notes : action.orderData.notes,
            notes_valid : true,
            notes_touched : false,
            status : action.orderData.status,
            paymentStatus : action.orderData.paymentStatus,
            geoLat : action.orderData.geoLat,
            geoLon : action.orderData.geoLon,
            donation : action.orderData.donation,
            donation_valid : true,
            donation_touched : false,
            cashAmount : action.orderData.cashAmount,
            cashAmount_valid : true,
            cashAmount_touched : false,
            checkAmount : action.orderData.checkAmount,
            checkAmount_valid : true,
            checkAmount_touched : false,
            checkNumber : action.orderData.checkNumber,
            checkNumber_valid : true,
            checkNumber_touched : false,
            total : action.orderData.total,
            totalBags : action.orderData.totalBags,
            isApproved : action.orderData.isApproved,
            inDeliveryArea : action.orderData.inDeliveryArea,
            isSuspect : action.orderData.isSuspect,
            geoAddress : action.orderData.geoAddress,
            touched : '',
            touchedByAdmin : ''    
        }
    };
};

const setAddCallListOrder = (state, action) => {

    return {
        ...state,
        errorMessage: null,
        submitted: false,
        order: {
            ...state.order,
            orderId: 0,
            userId: action.orderData.userId,
            isInArea: action.orderData.inDeliveryArea,
            name: action.orderData.name,
            name_valid: true,
            name_touched: true,
            address: action.orderData.address,
            address_valid: true,
            address_touched: true,
            city: action.orderData.city,
            city_valid: true,
            city_touched: true,
            zip: action.orderData.zip,
            zip_valid: true,
            zip_touched: true,
            phone: action.orderData.phone,
            phone_valid: true,
            phone_touched: true,
            email: action.orderData.email,
            email_valid: true,
            email_touched: true,
            cedarBags: action.orderData.cedarBags,
            cedarBags_valid: true,
            cedarBags_touched: true,
            hardwoodBags: action.orderData.hardwoodBags,
            hardwoodBags_valid: true,
            hardwoodBags_touched: true,
            blackBags: action.orderData.blackBags,
            blackBags_valid: true,
            blackBags_touched: true,
            redBags: action.orderData.redBags,
            redBags_valid: true,
            redBags_touched: true,
            cyprusBag: 0,
            cyprusBags_valid: true,
            cyprusBags_touched: true,
            deliveryType: action.orderData.deliveryType,
            deliveryType_valid: true,
            deliveryType_touched: true,
            notes: '',
            notes_valid: true,
            notes_touched: true,
            status: '',
            paymentStatus: 'unpaid',
            geoLat: action.orderData.geoLat,
            geoLon: action.orderData.geoLon,
            donation: 0,
            donation_valid: true,
            donation_touched: true,
            cashAmount: 0,
            cashAmount_valid: true,
            cashAmount_touched: true,
            checkAmount: 0,
            checkAmount_valid: true,
            checkAmount_touched: true,
            checkNumber: '',
            checkNumber_valid: true,
            checkNumber_touched: true,
            total: action.orderData.total,
            totalBags: action.orderData.totalBags,
            isApproved: false,
            inDeliveryArea: action.orderData.inDeliveryArea,
            isSuspect: false,
            geoAddress: action.orderData.geoAddress,
            touched: '',
            touchedByAdmin: '',
            purchased: false,
            salesSummary: {
                hardwoodBags: 0,
                cedarBags: 0,
                blackBags: 0,
                redBags: 0
            }
        }
    };
};

const updateOrder = (state, action) => {
    return {
        ...state,
        order: {
            ...state.order,
            [action.idToken]: action.value
        }
    }
};

const updateSearchCriteria = (state, action) => {
    return {
        ...state,
        searchCriteria : action.value
    }
};

const loadStart = ( state, action ) => {
    return {
        ...state, 
        errorMessage: null,
        loading: true 
    } 
};

const loadResult = (state, action) => {
    return {
        ...state,
        loading: false,
        [action.idToken]: action.value
    }
}

const loadResultArray = (state, action) => {
    let result = [];
        result = action.value;
        return {
            ...state,
            loading: false,
            [action.idToken]: result
        }
    
}


const searchAdminCallListSuccess = ( state, action ) => {
    return {
        ...state, 
        searchResults: action.searchResults,
        loading: false
    } ;
};




const submitOrderSuccess = (state, action) => {
    return {
        ...state,
        purchased: true,
        order : action.orderData
        
    };
};

const addPickupSuccess = (state, action) => {
    return {
        ...state,
        pickupCreated: true,
        pickupSummary : action.pickupSummary
        
    };
};


const submitEditOrderSuccess = (state, action) => {
    return {
        ...state,
        updated: true
    };
};

const messageFail = (state,action) => {
        return {
            ...state, 
            loading: false ,
            errorMessage: action.error
        }    
    
}


const addOrderToOrders = ( state, action ) => {
    const newOrder = updateObject( action.orderData, { status: 'initial' } );
    let ordr = state.orders.concat( newOrder );
    
    return  {
        ...state,
        orders: ordr
    };
}

const addDeliveryToDeliveries = ( state, action ) => {
    return  {
        ...state,
        deliveries: state.deliveries.concat( action.delivery )
    };
}



const updateExistingOrder = ( state, action ) => {
    return {
        ...state,
        updated: true,
        orders: action.orders
    };
}

const authSuccess = (state, action) => {
    return {
        ...state,  
        token: action.idToken,
        userId: action.userId,
        userType: action.userType,
        errorMessage: null,
        loading: false,
        orders: [],
     };
};

const signUpSuccess = (state, action) => {
    return {
        ...state,  
        token: action.idToken,
        userId: action.userId,
        userType: action.userType,
        errorMessage: null,
        loading: false
     };
};

const authLogout = (state, action) => {
    return {
        ...state, 
        token: null, 
        userId: null,
        userType: null, 
        token: null,
        userId: null,
        userType: null,
        authRedirectPath: '/',
        scouts: [],
        scoutsLastGot: null,
        orders: [],
        searchCriteria : '',
        searchResults: [],
        callList: []
    };
};

const setAuthRedirectPath = (state, action) => {
    return {
        ...state, 
        authRedirectPath: action.path 
    }
}



const getScoutsSuccess = ( state, action ) => {
    return {
        ...state, 
        scouts: action.scouts,
        loading: false,
        scoutsLastGot: new Date()
    } ;
};


const addSuccess = (state, action) => {
    return {
        ...state,
        added: true
    };
};

const updateSuccess = (state, action) => {
    return {
        ...state,
        updated: true
    };
};

const deleteSuccess = (state, action) => {
    return {
        ...state,
        deleted: true
    };
};

const updateDriverData = ( state, action ) => {
    return {
        ...state,
        driver: {
            ...state.driver,
            [action.idToken]: action.value
        }
    }
};

const driverPhoneValid = ( state, action ) => {
    return {
        ...state,
        driver: {
            ...state.driver,
            phone: action.value,
            phone_valid: true,
            phone_touched: true
        }
    }
};

const driverPhoneInValid = ( state, action ) => {
    return {
        ...state,
        driver: {
            ...state.driver,
            phone: action.value,
            phone_valid: false,
            phone_touched: false
        }
    }
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.LOAD_RESULT: return loadResult(state,action);
        case actionTypes.LOAD_RESULT_ARRAY: return loadResultArray(state,action);

        case actionTypes.ADD_ORDER_TO_ORDERS: return addOrderToOrders(state,action);
        case actionTypes.UPDATE_EXISTING_ORDER: return updateExistingOrder(state,action);
        case actionTypes.INIT_ORDER: return initOrder(state, action);
        case actionTypes.INIT_SEARCH_RESULTS: return initSearchResults(state,action);
        case actionTypes.UPDATE_ORDER: return updateOrder(state, action);
        case actionTypes.SUBMIT_ORDER_SUCCESS: return submitOrderSuccess(state, action);
        case actionTypes.SET_ADD_CALLLIST_ORDER: return setAddCallListOrder(state, action);
        case actionTypes.SET_EDIT_ORDER: return setEditOrder(state, action);
        case actionTypes.UPDATE_SEARCH_CRITERIA: return updateSearchCriteria(state, action);
        case actionTypes.SEARCH_ADMIN_CALLLIST_SUCCESS: return searchAdminCallListSuccess( state, action );
        case actionTypes.AUTH_SUCCESS: return authSuccess(state, action);
        case actionTypes.GET_SCOUTS_SUCCESS: return getScoutsSuccess(state, action);
        case actionTypes.SIGNUP_SUCCESS: return signUpSuccess(state, action);
        case actionTypes.AUTH_LOGOUT: return authLogout(state, action);
        case actionTypes.SET_AUTH_REDIRECT_PATH: return setAuthRedirectPath(state,action);
        case actionTypes.ADD_DELIVERY_TO_DELIVERIES: return addDeliveryToDeliveries(state,action);
        case actionTypes.MESSAGE_FAIL: return messageFail(state,action);
        case actionTypes.ADD_SUCCESS: return addSuccess(state,action);
        case actionTypes.UPDATE_SUCCESS: return updateSuccess(state,action);
        case actionTypes.DELETE_SUCCESS: return deleteSuccess(state,action);
        case actionTypes.INIT_DRIVER: return initDriver(state,action);
        case actionTypes.UPDATE_DRIVER_DATA: return updateDriverData(state,action);
        case actionTypes.DRIVER_PHONE_VALID: return driverPhoneValid(state,action);
        case actionTypes.DRIVER_PHONE_INVALID: return driverPhoneInValid(state,action);

        default: return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/orders.js